import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Toaster } from "react-hot-toast";

import RouteLoader from "./components/RouteLoader";
import ErrorNotFound from "./components/ErrorNotFound";
import ProtectedRoute from "./components/routes/ProtectedRoute";
import PublicRoute from "./components/routes/PublicRoute";
import DashboardLayout from "./containers/Dashboard/DashboardLayout";
import LoginPage from "./pages/public-pages/LoginPage";
import ForgotPasswordPage from "./pages/public-pages/ForgotPasswordPage";

const RouteLoaderWrapper = ({ children }) => {
  const location = useLocation();
  const prevLocation = useRef(location.pathname);
  const [showRouteLoader, setShowRouteLoader] = useState(false);

  useEffect(() => {
    if (prevLocation.current !== location.pathname) {
      console.log(
        "Route changed from",
        prevLocation.current,
        "to",
        location.pathname,
      );
      setShowRouteLoader(true);
      // Simulate loader duration for route transition
      const timer = setTimeout(() => {
        setShowRouteLoader(false);
        prevLocation.current = location.pathname;
      }, 500);

      return () => clearTimeout(timer);
    }
  }, [location]);

  return (
    <>
      {showRouteLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: 9999,
            backgroundColor: "rgba(255,255,255,0.9)",
          }}
        >
          <RouteLoader />
        </div>
      )}
      {children}
    </>
  );
};

const App = () => {
  return (
    <Router>
      <RouteLoaderWrapper>
        <Toaster
          position="bottom-right"
          reverseOrder={false}
          toastOptions={{
            style: {
              color: "#666",
              fontSize: 14,
              letterSpacing: 0.3,
              fontFamily: "Poppins",
            },
          }}
        />
        <Routes>
          <Route path="" element={<PublicRoute redirectRoute={"/groups"} />}>
            <Route exact path="/login" element={<LoginPage />} />
            <Route
              exact
              path="/forgot-password"
              element={<ForgotPasswordPage />}
            />

            <Route index element={<Navigate replace to="/login" />} />
          </Route>

          <Route path="" element={<ProtectedRoute redirectRoute={"/login"} />}>
            <Route path="/*" element={<DashboardLayout />} />
          </Route>

          <Route path="*" element={<Navigate replace to="/" />} />

          <Route element={<ErrorNotFound />} />
        </Routes>
      </RouteLoaderWrapper>
    </Router>
  );
};

export default App;
